var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUserDefaultImage = function SvgUserDefaultImage(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 28,
    cy: 28,
    r: 28
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12 -12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    x: 12,
    y: 12,
    fill: "#E0E0E0",
    fillRule: "nonzero",
    rx: 28
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(23 20)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.997,
    height: 34.682,
    x: 2.501,
    y: 0.392,
    fill: "#FFF",
    rx: 11.673
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M20.844 35.453h-7.688C7.066 35.446 2.13 30.51 2.122 24.419V11.046C2.13 4.956 7.065.02 13.156.013h7.688c6.091.007 11.027 4.943 11.034 11.033V24.42c-.007 6.091-4.943 11.027-11.034 11.034zM13.156.77C7.484.777 2.887 5.374 2.88 11.046V24.42c.007 5.673 4.604 10.27 10.276 10.276h7.688c5.672-.007 10.269-4.604 10.276-10.276V11.046C31.113 5.374 26.516.778 20.844.771h-7.688z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17 33.691c-6.193.019-11.21 5.035-11.227 11.228V55.11h22.455V44.92C28.209 38.725 23.193 33.71 17 33.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M28.227 55.49H5.773a.379.379 0 0 1-.38-.38V44.92a11.606 11.606 0 1 1 23.213 0v10.19a.379.379 0 0 1-.379.38zm-22.075-.76h21.696v-9.812a10.848 10.848 0 1 0-21.696 0v9.812z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M5.773 44.92v10.19h22.455V44.92C28.209 38.725 23.193 33.71 17 33.69c-6.193.019-11.21 5.035-11.227 11.228z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17 38.096a3.091 3.091 0 0 0 3.082-3.082v-5.036h-6.164v5.036A3.091 3.091 0 0 0 17 38.096z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M17 38.475a3.465 3.465 0 0 1-3.461-3.46v-5.038a.379.379 0 0 1 .379-.379h6.164a.379.379 0 0 1 .379.38v5.036A3.465 3.465 0 0 1 17 38.475zm-2.703-8.119v4.658a2.703 2.703 0 0 0 5.406 0v-4.658h-5.406z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.197,
    height: 28.371,
    x: 4.902,
    y: 3.981,
    fill: "#FFF",
    rx: 9.551
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M19.794 32.731h-5.587a9.695 9.695 0 0 1-9.684-9.684v-9.761a9.695 9.695 0 0 1 9.684-9.683h5.587a9.695 9.695 0 0 1 9.684 9.683v9.761a9.695 9.695 0 0 1-9.684 9.684zm-5.587-28.37a8.936 8.936 0 0 0-8.926 8.925v9.761a8.936 8.936 0 0 0 8.926 8.926h5.587a8.936 8.936 0 0 0 8.926-8.926v-9.761a8.936 8.936 0 0 0-8.926-8.925h-5.587z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M1.135 18.145A3.775 3.775 0 0 0 4.9 21.91v-7.527a3.775 3.775 0 0 0-3.764 3.763z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M4.9 22.288a4.143 4.143 0 0 1 0-8.286.379.379 0 0 1 .378.38v7.527a.379.379 0 0 1-.379.379zm-.38-7.507a3.385 3.385 0 0 0 0 6.728v-6.728z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M29.1 14.382v7.527a3.764 3.764 0 0 0 0-7.527z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M29.1 22.288a.379.379 0 0 1-.378-.38v-7.527a.379.379 0 0 1 .379-.379 4.143 4.143 0 0 1 0 8.286zm.38-7.507v6.728a3.385 3.385 0 0 0 0-6.728z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.602,
    cy: 17.983,
    r: 1.405,
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.398,
    cy: 17.983,
    r: 1.405,
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M13.336 25.378a3.927 3.927 0 0 0 7.328 0h-7.328z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M27.077 9.453c0 .463-.112.918-.325 1.329a2.92 2.92 0 0 0-2.589-1.585H9.837A2.92 2.92 0 0 1 6.929 6.41c-.002-.043-.006-.085-.006-.128V3.369A2.922 2.922 0 0 1 9.837.455h14.326a2.922 2.922 0 0 1 2.914 2.914v2.914c0 .043-.004.085-.006.128.002.043.006.085.006.128v2.914z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M26.752 11.161a.38.38 0 0 1-.337-.205 2.53 2.53 0 0 0-2.251-1.38H9.837A3.285 3.285 0 0 1 6.55 6.428l-.007-.145V3.37A3.296 3.296 0 0 1 9.837.076h14.327a3.296 3.296 0 0 1 3.293 3.293v2.914l-.005.102.005.154v2.914c0 .523-.126 1.04-.368 1.503a.379.379 0 0 1-.337.205zM9.837.834a2.538 2.538 0 0 0-2.535 2.535v2.914l.006.111a2.528 2.528 0 0 0 2.529 2.424h14.327c.954 0 1.861.415 2.483 1.138.035-.166.052-.334.052-.503V6.54l-.007-.142.386-.114h-.38V3.37A2.538 2.538 0 0 0 24.165.834H9.837z"
  })))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUserDefaultImage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user_default_image.eb5c402d05d3ab6e929d22ed025d50e0.svg";